module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[109]352.512cf47.woff2";